import { SecurityRulesState } from "@idw-types/state/security-rules-state";
import { SecurityRulesActionTypes, SecurityRulesActions } from "../actions/security-rules-actions";

export const initialSecurityRulesState: SecurityRulesState = {
    securityRules: {
        isLoading: false,
        securityRules: null
    },
    isRefreshing: false,
    lastRefreshDate: null,
    refreshResults: null
};

export const securityRulesReducer = (
    state: SecurityRulesState = initialSecurityRulesState,
    action: SecurityRulesActions
): SecurityRulesState => {
    switch (action.type) {
        case SecurityRulesActionTypes.SET_SECURITY_RULES_LOADING:
            return {
                ...state,
                securityRules: {
                    ...(action.payload.isLoading
                        ? { ...initialSecurityRulesState.securityRules }
                        : { ...state.securityRules }),
                    isLoading: action.payload.isLoading
                }
            };
        case SecurityRulesActionTypes.SET_SECURITY_RULES:
            return {
                ...state,
                securityRules: {
                    ...state.securityRules,
                    securityRules: action.payload.securityRules,
                    isLoading: false
                }
            };
        case SecurityRulesActionTypes.ADD_SECURITY_RULE:
            return {
                ...state,
                securityRules: {
                    ...state.securityRules,
                    securityRules: state.securityRules.securityRules
                        ? [...state.securityRules.securityRules, action.payload.securityRule]
                        : [action.payload.securityRule]
                }
            };
        case SecurityRulesActionTypes.REPLACE_SECURITY_RULE:
            return {
                ...state,
                securityRules: {
                    ...state.securityRules,
                    securityRules: state.securityRules.securityRules
                        ? state.securityRules.securityRules.map(sr => sr.id === action.payload.securityRule.id ? action.payload.securityRule : sr)
                        : []
                }
            };
        case SecurityRulesActionTypes.SET_SECURITY_RULES_REFRESHING:
            return {
                ...state,
                isRefreshing: action.payload.isRefreshing
            };
        case SecurityRulesActionTypes.SET_SECURITY_RULES_REFRESH_RESULTS:
            return {
                ...state,
                isRefreshing: false,
                refreshResults: action.payload.refreshResults,
                lastRefreshDate: action.payload.lastRefreshDate,
            };
        default:
            return state;
    }
};